import React from 'react';
import {
  Modal as KitbagModal,
  ModalHeader,
  Button,
  ButtonIcon,
  ModalBody,
  ModalFooter,
} from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

/**
 * Modal component used internally within the MultiStepModal component
 */
function Modal({
  isOpen,
  children,
  title,
  onPreviousButtonClick,
  onNextButtonClick,
  previousButtonLabel,
  nextButtonLabel,
  onClose,
  isDisabledPreviousButton,
  isDisabledNextButton,
  isDisabledEscape,
  id,
  isConfirmPending,
}) {
  const intl = useIntl();

  return (
    <KitbagModal
      isOpen={isOpen}
      id={id}
      onEscape={onClose}
      isDisabledEscape={isDisabledEscape}
    >
      <ModalHeader id={`${id}-header`}>
        {title}
        <ButtonIcon
          icon="Close"
          variant="ghost"
          size="small"
          title={intl.formatMessage({
            defaultMessage: 'Close',
            id: 'd3d2e',
          })}
          onClick={onClose}
          disabled={isDisabledEscape}
        />
      </ModalHeader>
      <ModalBody>{children}</ModalBody>
      <ModalFooter>
        <Button
          onClick={onPreviousButtonClick}
          variant="ghost"
          isDisabled={isDisabledPreviousButton}
        >
          {previousButtonLabel}
        </Button>

        <Button
          onClick={onNextButtonClick}
          isDisabled={isDisabledNextButton}
          isPending={isConfirmPending}
        >
          {nextButtonLabel}
        </Button>
      </ModalFooter>
    </KitbagModal>
  );
}

Modal.defaultProps = {
  isConfirmPending: false,
  isDisabledEscape: false,
  isDisabledNextButton: false,
  isDisabledPreviousButton: false,
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  isConfirmPending: PropTypes.bool,
  isDisabledEscape: PropTypes.bool,
  isDisabledNextButton: PropTypes.bool,
  isDisabledPreviousButton: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  nextButtonLabel: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onNextButtonClick: PropTypes.func.isRequired,
  onPreviousButtonClick: PropTypes.func.isRequired,
  previousButtonLabel: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Modal;
